import { v4 as uuid } from "uuid";

import { HttpPayload } from "frontend/interfaces/http";
import { Room, RoomNew, RoomRaw } from "frontend/interfaces/room";
import { RoomWithType } from "frontend/interfaces/calendar";

export function parseRoom(room: RoomRaw): Room {
  return { ...room };
}

export function httpPayloadRoom(room: RoomRaw): HttpPayload {
  return {
    ...room,
  };
}

export function newRoom(): RoomNew {
  return {
    id: `MOCK-${uuid()}`,
    name: "",
    location_id: null,
    unsaved: true,
  };
}

export function isRoom(roomCandidate: unknown): roomCandidate is Room {
  const room = roomCandidate as RoomWithType;

  return (
    !!room &&
    typeof room === "object" &&
    typeof room.name === "string" &&
    typeof room.id === "string" &&
    room.type === "room"
  );
}
